import { compareByName } from './compareByName';

export type TenantHierarchyItem = {
  id: string;
  name: string;
  roles: string[];
  isSubTenant?: boolean;
  parentId?: string | null;
};

export type TenantWithChildren = TenantHierarchyItem & {
  children: TenantHierarchyItem[];
};

export function buildTenantHierarchy(
  tenants: TenantHierarchyItem[],
): TenantWithChildren[] {
  const result: TenantWithChildren[] = [];
  const subTenantsByParent = new Map<string, TenantHierarchyItem[]>();
  const parentIds = new Set<string>();
  const seenIds = new Set<string>();

  for (const tenant of tenants) {
    if (seenIds.has(tenant.id)) {
      continue;
    }
    seenIds.add(tenant.id);

    if (tenant.isSubTenant && tenant.parentId) {
      const existing = subTenantsByParent.get(tenant.parentId) ?? [];
      existing.push(tenant);
      subTenantsByParent.set(tenant.parentId, existing);
    } else {
      parentIds.add(tenant.id);
      result.push({ ...tenant, children: [] });
    }
  }

  for (const parent of result) {
    parent.children = (subTenantsByParent.get(parent.id) ?? []).sort(
      compareByName,
    );
  }

  for (const [parentId, subTenants] of subTenantsByParent) {
    if (!parentIds.has(parentId)) {
      for (const orphan of subTenants) {
        result.push({ ...orphan, children: [] });
      }
    }
  }

  return result.sort(compareByName);
}
